import * as React from "react";
import { useSiteAboutStore } from "../siteAboutStore/siteAboutStore";
import { useFlexIgnoreZonesOnboardingStore } from "./flexIgnoreZonesOnboardingStore";
import { buildFlexIzScheduleSummary } from "./flexIzScheduleSummary";
import { SiteInfo } from "../SiteAboutPageUtils/siteAboutInterfaces";
import {
  FLEX_IZ_LD_EMPTY_CAMERAS,
  FLEX_IZ_LD_EMPTY_PRESET_ASSIGNMENTS,
  FLEX_IZ_LD_EMPTY_PRESET_NAMES,
  FLEX_IZ_LD_EMPTY_PRESETS,
  FLEX_IZ_LD_EMPTY_SCHEDULES,
  FLEX_IZ_LD_EMPTY_SELECTED_CAMERAS,
  flexIgnoreZonesNoopLoadCameraContext,
} from "./flexIgnoreZonesLdEmpty";

export function useFlexIzScheduleSummary(
  siteInfo: SiteInfo,
  options: {
    showFlexIgnoreZones: boolean;
    flexScheduleActive: boolean;
    flexIgnoreZonesEnabled: boolean;
  }
) {
  const { siteSchedules, schedulesIndex } = useSiteAboutStore();
  const ldFlexIz = options.showFlexIgnoreZones;
  const siteId = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.siteId : null
  );
  const wizardSchedules = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.schedules : FLEX_IZ_LD_EMPTY_SCHEDULES
  );
  const cameras = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.cameras : FLEX_IZ_LD_EMPTY_CAMERAS
  );
  const selectedCameraIdsBySchedule = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.selectedCameraIdsBySchedule : FLEX_IZ_LD_EMPTY_SELECTED_CAMERAS
  );
  const selectedPresetByScheduleCamera = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.selectedPresetByScheduleCamera : FLEX_IZ_LD_EMPTY_PRESET_ASSIGNMENTS
  );
  const presetsByCamera = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.presetsByCamera : FLEX_IZ_LD_EMPTY_PRESETS
  );
  const presetNamesByCamera = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.presetNamesByCamera : FLEX_IZ_LD_EMPTY_PRESET_NAMES
  );
  const loadCameraContext = useFlexIgnoreZonesOnboardingStore((state) =>
    ldFlexIz ? state.loadCameraContext : flexIgnoreZonesNoopLoadCameraContext
  );

  const summary = React.useMemo(
    () =>
      buildFlexIzScheduleSummary({
        showFlexIgnoreZones: options.showFlexIgnoreZones,
        flexScheduleActive: options.flexScheduleActive,
        flexIgnoreZonesEnabled: options.flexIgnoreZonesEnabled,
        siteId,
        siteInfoId: siteInfo.id,
        siteSchedules,
        schedulesIndex,
        wizardSchedules,
        selectedCameraIdsBySchedule,
        selectedPresetByScheduleCamera,
        cameras,
        presetsByCamera,
        presetNamesByCamera,
      }),
    [
      options.showFlexIgnoreZones,
      options.flexScheduleActive,
      options.flexIgnoreZonesEnabled,
      siteId,
      siteInfo.id,
      siteSchedules,
      schedulesIndex,
      wizardSchedules,
      selectedCameraIdsBySchedule,
      selectedPresetByScheduleCamera,
      cameras,
      presetsByCamera,
      presetNamesByCamera,
    ]
  );

  React.useEffect(() => {
    if (!summary) {
      return;
    }
    summary.rows.forEach((row) => {
      loadCameraContext(row.cameraId);
    });
  }, [summary, loadCameraContext]);

  return summary;
}
